import { on } from "@ngrx/store";
import { SalesOrderActions } from "./sales-order.actions";
import { SalesOrdersActions } from "./sales-orders/sales-orders.actions";
import { initialSalesOrderState, SalesOrderState } from "./sales-order.state";
import { salesOrdersReducer } from "./sales-orders/sales-orders.reducer";
import { PagesStore } from "../pages.state";

// **************************************************************************
// HELPER: Update salesOrder state within PagesStore
// **************************************************************************

function withSalesOrder(state: PagesStore, updater: (salesOrder: SalesOrderState) => SalesOrderState): PagesStore {
    return { ...state, salesOrder: updater(state.salesOrder) };
}

// **************************************************************************
// SALES ORDER REDUCER (array format for PagesStore)
// **************************************************************************

export const salesOrderReducer = [
    // **************************************************************************
    // DETAIL
    // **************************************************************************
    on(SalesOrderActions.load, (state: PagesStore) => withSalesOrder(state, salesOrderState => ({
        ...salesOrderState,
        error: null,
        loadingDetail: true,
    }))),

    on(SalesOrderActions.loadSuccess, (state: PagesStore, { salesOrder }) => withSalesOrder(state, salesOrderState => ({
        ...salesOrderState,
        salesOrder,
        error: null,
        loadingDetail: false,
    }))),

    on(SalesOrderActions.loadFailure, (state: PagesStore, { error }) => withSalesOrder(state, salesOrderState => ({
        ...salesOrderState,
        error,
        loadingDetail: false,
    }))),

    on(SalesOrderActions.reset, (state: PagesStore) => withSalesOrder(state, () => initialSalesOrderState)),

    // **************************************************************************
    // LIST LOADING
    // **************************************************************************
    on(SalesOrdersActions.load, (state: PagesStore) => withSalesOrder(state, salesOrderState => ({
        ...salesOrderState,
        loadingList: true,
    }))),

    on(
        SalesOrdersActions.loadSuccess,
        SalesOrdersActions.loadFailure,
        (state: PagesStore) => withSalesOrder(state, salesOrderState => ({
            ...salesOrderState,
            loadingList: false,
        }))
    ),

    // **************************************************************************
    // ERROR
    // **************************************************************************
    on(SalesOrderActions.clearError, (state: PagesStore) => withSalesOrder(state, salesOrderState => ({
        ...salesOrderState,
        error: null,
    }))),

    // **************************************************************************
    // NESTED REDUCERS
    // **************************************************************************
    ...salesOrdersReducer,
];
